import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { MDBIcon } from "mdb-react-ui-kit";
export default memo(({ data, isConnectable }) => {
  function onDelete(id) {
    data.onDelete(id);
  }
  return (
    <>
      <div className="endcallNodeHeader">
        {data.label}
        <MDBIcon
          fas
          icon="times"
          className="cursor-pointer"
          color="light"
          onClick={() => onDelete(data.id)}
        ></MDBIcon>
      </div>
      <Handle
        type="target"
        position={Position.Left}
        id="target"
        isConnectable={isConnectable}
      ></Handle>
      <div style={{ padding: "15px" }}>Hang up the call</div>
    </>
  );
});
